import { render, staticRenderFns } from "./InsuredAddressForm.vue?vue&type=template&id=397443d5&"
import script from "./InsuredAddressForm.vue?vue&type=script&lang=js&"
export * from "./InsuredAddressForm.vue?vue&type=script&lang=js&"
import style0 from "./InsuredAddressForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports